import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import { withStyles } from '@material-ui/core/styles';

import Illustration from '../../Illustration';
import ReceiptCard from './ReceiptCard';
import { selectReceiptsList } from '../../../store/selectors';

const styles = theme => ({
  root: {
  },

});

const ReceiptsCards = ({ classes, receipts, handleEdit, startEditAdmin }) => {
  return(
    <div className={classes.root}>
      {receipts.length > 0 &&
        receipts.map((receipt, i) => {
          return <ReceiptCard key={i} receipt={receipt} handleEdit={handleEdit}/>
        })
      }
      {receipts.length === 0 &&
        <Illustration
          title="Hmm, no Receipts..."
          imgKey="successful_purchase_amber"
          explainerText="Either you've not entered any or your filter had no results."
          addItemText="Enter a new Receipt by clicking the 'Floating Action Button' at top right."        />
      }
    </div>
  );
};

const mapStateToProps = (state, props) => {
  const { project } = props;
  return {
    receipts: selectReceiptsList(state, project),
  };
};


export default compose(
  withStyles(styles),
  connect(mapStateToProps)
)(ReceiptsCards);



// WEBPACK FOOTER //
// ./src/components/admin/Receipts/ReceiptsCards.jsx